export class Usuario {
    id: number;
    nome: string;
    sobrenome: string;
    celular: string;
    email: string;
    senha: string;
}